module.exports = __webpack_public_path__ + "static/media/ic-fun.6bdc8a65.svg";